<template>
  <div class="main">
    <mt-header :title="$t('默认语言')" fixed class="dl_header_white">
      <mt-button icon="back" slot="left" @click="goback"></mt-button>
    </mt-header>
    <div class="container">
      <mt-radio align="right" v-model="checkValue" :options="defaultResult"></mt-radio>
    </div>
  </div>
</template>

<script>
import { Toast } from "mint-ui";
export default {
  name: "Setlanguage",
  components: { Toast },
  data() {
    return {
      checkValue: this.$store.state.language
    };
  },
  created() {
    this.currencyList = [
      { 'name': 'English', 'val': 'en' },
      { 'name': '한국어', 'val': 'ko' },
      { 'name': '日本', 'val': 'ja' },
      { 'name': '繁體中文', 'val': 'hk' },
      { 'name': '简体中文', 'val': 'zh' }
    ];//
  },
  computed: {
    defaultResult: function () {
      return this.currencyList.map(function (item) {
        return {
          label: item.name,
          value: item.val
        }
      })
    }
  },
  methods: {
    goback: function () {
      this.$router.back();
    }
  },
  watch: {
    checkValue: function (val, old) {
      this.$store.dispatch("setLanguage", val);
      this.$i18n.locale = val;
      window.localStorage.set('language', val)
    }
  }
};
</script>

<style scoped>
.main {
  padding-top: 40px;
}
.container {
  padding: 50px 10px 10px 10px;
}
</style>

